module.exports = __webpack_public_path__ + "static/media/Employer_1.63fff906.svg";